import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * Constants
 */
export const REQUEST = '@app/orders/filter/REQUEST';
export const SUCCESS = '@app/orders/filter/SUCCESS';
export const FAILURE = '@app/orders/filter/FAILURE';
export const CLEAR = '@app/orders/filter/CLEAR';

/**
 * Initial state
 */
const initState = {
    items: [],
    loading: false,
    errorStatus: ''
};

const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.items = payload;
                draft.loading = false;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                draft.loading = false;
                break;
            case REQUEST:
                draft.loading = true;
                draft.errorStatus = '';
                break;
            case CLEAR:
                draft.items = [];
                draft.loading = false;
                draft.errorStatus = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const response = yield axios.get(
                `orders/workers/${payload.orderId}${payload.search ? `?${payload.search}` : ''}`
            );
            yield put(actions.success(response.data.data));
        } catch (e) {
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
